'use client';

/**
 * PublicProfileQR — small client wrapper around `qrcode.react`'s `QRCodeSVG`
 * so it can be embedded in the server-rendered public profile page
 * (`app/p/[username]/page.tsx`). The page itself must stay a Server Component
 * for SEO + ISR (see its docstring), but `qrcode.react` v4 requires a client
 * boundary to render the SVG (it uses layout effects internally).
 *
 * fix(spec-045-A4-MED-001): SPEC-NEGOCIO §1.3 mandates a QR section in the
 * public Virtual Card. The private `VirtualCard` component already renders
 * one (it's `'use client'`), but the public SSR page had no QR section.
 */

import { QRCodeSVG } from 'qrcode.react';

interface PublicProfileQRProps {
  value: string;
  size?: number;
}

export function PublicProfileQR({ value, size = 128 }: PublicProfileQRProps) {
  return (
    <div
      className="bg-white rounded-lg border border-border flex items-center justify-center p-2"
      style={{ width: size + 16, height: size + 16 }}
    >
      <QRCodeSVG value={value} size={size} level="M" />
    </div>
  );
}
